import ProjectsService from '../../services/ProjectsService'
import OrganizationService from '../../services/OrganizationService'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'
import router from '../../router'
import { Project } from 'paper/dist/paper-core'
import PoiService from '../../services/PoiService'
import Enums from '../../helpers/Enums'
export const namespaced = true

const initialState = {
  projects: [],
  selectedProject: {},
  selectedProjectMedia: [],
  selectedProjectReservations: [],
  usersOnProject: [],
  projectConfig: {},
  hasTitleMediaItem: false,
  hasDescriptionMediaItem: false,
  hasTitleImageMediaItem: false
}

export const state = {
  projects: [],
  selectedProject: {},
  selectedProjectMedia: [],
  selectedProjectReservations: [],
  usersOnProject: [],
  projectConfig: {},
  hasTitleMediaItem: false,
  hasDescriptionMediaItem: false,
  hasTitleImageMediaItem: false
}

export const mutations = {
  SET_PROJECTS(state, recs) {
    state.projects = recs
  },
  SET_SELECTED_PROJECT(state, rec) {
    state.selectedProject = rec
  },
  SET_SELECTED_PROJECT_MEDIA(state, rec) {
    state.selectedProjectMedia = rec
  },
  SET_SELECTED_PROJECT_RESERVATIONS(state, recs) {
    state.selectedProjectReservations = recs
  },
  SET_USERS_ON_PROJECT(state, recs) {
    state.usersOnProject = recs
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  },
  GET_PROJECT_SETTINGS(state, rec) {
    state.projectConfig = rec
  },
  SET_HAS_TITLE_MEDIA_ITEM(state, value) {
    state.hasTitleMediaItem = value
  },
  SET_HAS_DESCRIPTION_MEDIA_ITEM(state, value) {
    state.hasDescriptionMediaItem = value
  },
  SET_HAS_TITLE_IMAGE_MEDIA_ITEM(state, value) {
    state.hasTitleImageMediaItem = value
  }
}

export const actions = {
  fetchProjects: function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    ProjectsService.getProjects().then(
      r => {
        context.commit('SET_PROJECTS', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_PROJECTS', [])
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  setSelectedProject: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    try {
      let project = await ProjectsService.getProjectById(value)
      context.commit('SET_SELECTED_PROJECT', project.data)

      await context.dispatch('checkProjectHasRequiredMediaItems')
    } catch (e) {
      context.commit('SET_SELECTED_PROJECT', null)
      AxiosErrorHandler.handler(e, context, router)
    }
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  },
  setSelectedProjectReservations: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ProjectsService.getProjectReservations(value).then(
      r => {
        context.commit('SET_SELECTED_PROJECT_RESERVATIONS', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_SELECTED_PROJECT_RESERVATIONS', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  createProject: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    try {
      const project = await ProjectsService.createProject(value)
      console.log('projekat', project)
      let data = {
        projectsId: project.data.id,
        organizationsId: value.organizationsId
      }
      await OrganizationService.createOrganizationProject(data)
    } catch (error) {
      throw error
    }
  },
  updateProject: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ProjectsService.updateProject(value).then(
      r => {
        context.commit('SET_SELECTED_PROJECT', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        context.dispatch(
          'OrganizationStore/fetchProjectsForOrganization',
          context.rootGetters['OrganizationStore/getSelectedOrganizationId'],
          {
            root: true
          }
        )
        context.dispatch(
          'NotificationStore/add',
          { type: 'info', message: 'Project data successfully updated' },
          { root: true }
        )
      },
      e => {
        context.commit('SET_SELECTED_PROJECT', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  getSelectedProjectSettings: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ProjectsService.getProjectSettings(value).then(
      r => {
        context.commit('GET_PROJECT_SETTINGS', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        // context.commit('SET_SELECTED_PROJECT_SETTINGS', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  setSelectedProjectSettings: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ProjectsService.setProjectSettings(value).then(
      r => {
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  deleteProject: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    try {
      await ProjectsService.deleteProject(value)
    } catch (error) {
      throw error
    }
  },
  getUsersOnProject: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    ProjectsService.getUsersOnProject(value).then(
      r => {
        context.commit('SET_USERS_ON_PROJECT', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_USERS_ON_PROJECT', [])
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  },
  setTitleImage: async function(context, value) {
    let result
    try {
      result = await ProjectsService.setTitleImage(
        value.projectId,
        value.mediaId
      )
    } catch (e) {
      AxiosErrorHandler.handler(e, context, router)
    }
    return result
  },
  checkProjectHasRequiredMediaItems: async function({
    commit,
    getters,
    state
  }) {
    if (!state.selectedProject) {
      console.warn('selectedProject not set', state.selectedProject)
      return
    }

    let media = await ProjectsService.getProjectMedia(
      state.selectedProject.id,
      {
        pageNumber: 0,
        pageSize: 0,
        mediaTypeId: 0,
        langId: 0
      }
    )
    commit(
      'SET_HAS_TITLE_MEDIA_ITEM',
      !!media.data.find(
        m =>
          m.langId === getters.getDefaultLangId &&
          [Enums.MediaType.project_title].includes(m.mediaTypeId)
      )
    )
    commit(
      'SET_HAS_DESCRIPTION_MEDIA_ITEM',
      !!media.data.find(
        m =>
          m.langId === getters.getDefaultLangId &&
          [Enums.MediaType.project_text_description].includes(m.mediaTypeId)
      )
    )
    commit(
      'SET_HAS_TITLE_IMAGE_MEDIA_ITEM',
      !!media.data.find(m => {
        return (
          m['ProjectContent'] &&
          m['ProjectContent']['properties'] &&
          Object.prototype.hasOwnProperty.call(
            m['ProjectContent']['properties'],
            'order'
          ) &&
          m['ProjectContent']['properties'].order === 1 &&
          [Enums.MediaType.project_title_image].includes(m.mediaTypeId)
        )
      })
    )
  },
  getTitleImage: async function(context, value) {
    let response = await ProjectsService.getProjectTitleImage(
      context.state.selectedProject.id,
      {
        langId: value
      }
    )
    return response.data
  }
}

export const getters = {
  getSelectedProjectId: state => {
    return state.selectedProject ? state.selectedProject.id : 0
  },
  getDefaultLangId: state => {
    return state.projectConfig[state.projectConfig.length - 1].mediaData
      .defaultLangId
  },
  showTitleMediaItemGhost: state => {
    return !state.hasTitleMediaItem
  },
  showDescriptionMediaItemGhost: state => {
    return !state.hasDescriptionMediaItem
  },
  showTitleImageMediaItemGhost: state => {
    return !state.hasTitleImageMediaItem
  }
}
